import React from 'react';
import { useLang } from './LangContext';

const Link = ({ href, children }) => (
  <a href={href} className="info-link" target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}>
    {children}
  </a>
);

const ContactDE = () => (
  <div className="info-page-shell">
    <div className="info-page">
      <section className="content-card info-card info-hero-card">
        <p className="eyebrow">Pomodoro Flow</p>
        <h1>Kontakt</h1>
        <p className="lead info-intro">
          Ich freue mich, von dir zu hören. Egal ob Fragen, Vorschläge oder eine kurze Nachricht – melde dich gern.
        </p>
      </section>

      <div className="info-page-stack">
        <section className="content-card info-card">
          <h2>Direkte Wege</h2>
          <ul className="info-list info-contact-list">
            <li>
              <strong>E-Mail:</strong> <Link href="mailto:pomodoro.flow.yt@gmail.com">pomodoro.flow.yt@gmail.com</Link>
            </li>
            <li>
              <strong>YouTube-Kanal:</strong>{' '}
              <Link href="https://www.youtube.com/channel/UC8E1eJvIbv82zyEMmBxDyOQ">Kanal besuchen</Link>
            </li>
          </ul>
        </section>

        <section className="content-card info-card">
          <h2>Worum es gehen kann</h2>
          <p>Feedback zur Bedienung, Ideen für neue Funktionen, Fehlerberichte oder einfache Rückmeldungen zur Nutzung im Alltag.</p>
          <p>Danke, dass du Teil von Pomodoro Flow bist.</p>
        </section>
      </div>
    </div>
  </div>
);

const ContactEN = () => (
  <div className="info-page-shell">
    <div className="info-page">
      <section className="content-card info-card info-hero-card">
        <p className="eyebrow">Pomodoro Flow</p>
        <h1>Contact</h1>
        <p className="lead info-intro">
          I love hearing from you. Questions, suggestions, bug reports, or a quick hello are all welcome.
        </p>
      </section>

      <div className="info-page-stack">
        <section className="content-card info-card">
          <h2>Direct ways to reach out</h2>
          <ul className="info-list info-contact-list">
            <li>
              <strong>Email:</strong> <Link href="mailto:pomodoro.flow.yt@gmail.com">pomodoro.flow.yt@gmail.com</Link>
            </li>
            <li>
              <strong>YouTube channel:</strong>{' '}
              <Link href="https://www.youtube.com/channel/UC8E1eJvIbv82zyEMmBxDyOQ">Visit the channel</Link>
            </li>
          </ul>
        </section>

        <section className="content-card info-card">
          <h2>What you can write about</h2>
          <p>Feedback on the timer experience, ideas for new features, bug reports, or general thoughts after using the app.</p>
          <p>Thanks for being part of Pomodoro Flow.</p>
        </section>
      </div>
    </div>
  </div>
);

const Contact = () => {
  const { lang } = useLang();
  return lang === 'de' ? <ContactDE /> : <ContactEN />;
};

export default Contact;
